import React from 'react'

import { ButtonBase } from '@mui/material'
import classNames from 'classnames/bind'

import { HomeIcon } from '~/assets/icons'
import styles from './TopHeader.module.scss'
import { getInfoRestaurant, getURLFromHomeIconTablet } from '~/utils'
import { getInfoRestaurantApi } from '~/apis/home'
import { useDispatch } from 'react-redux'
import { saveDataRestaurant } from '~/redux/restaurantSlice'
import { useNavigate } from 'react-router-dom'
import { path } from '~/routes/path'
import { useTranslation } from 'react-i18next'

const cx = classNames.bind(styles)

// Top header trên tablet
const TopHeader = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleClickHome = async () => {
    const { restaurantSlug, tableUid } = getInfoRestaurant()

    const data = await getInfoRestaurantApi(
      {
        restaurantSlug,
        tableUid,
      },
      {},
    )

    const { isSuccess, extraFeatures } = data || {}

    if (isSuccess) {
      // lưu lại trên redux để sử dụng ở các màn
      dispatch(saveDataRestaurant(data))
      const URL = getURLFromHomeIconTablet(extraFeatures)
      navigate(URL)
    } else {
      navigate(path.rescanQR)
      localStorage.clear()
    }
  }

  return (
    <div className={cx('wrapper')}>
      <ButtonBase className={cx('button')} onClick={handleClickHome}>
        <span className={`text-line-1 ${cx('text')}`}>{t('titles.top')}</span>
        <HomeIcon size="45" />
      </ButtonBase>
    </div>
  )
}

export default TopHeader
